<template>
  <div style="height:650px">
    <div class="newsContent" v-show="state1">
      <div
        class="newsInfoTitleList"
        v-for="(item,index) in newsContentData"
        :key="index"
        @click="intoNextPage(item.infoservice_content)"
      >
        <div class="newsInfoTitleListPic">
          <img :src="item.img_url">
        </div>
        <div class="newsInfoTitleListText">
          <p>
            <span>{{item.title_name.replace(reg,'').slice(0,60)}}...</span>
          </p>
          <p>{{item.create_time | getTimeData}}</p>
        </div>
      </div>
    </div>
    <div class="newstext" style="height:650px" v-html="html" v-show="state2"></div>
  </div>
</template>
<script>
import Axios from "axios";
export default {
  name: "cxts",
  data() {
    return {
      html: "",
      state1: true,
      state2: false,
      newsContentData: "",
      reg: /<[^>]*>|<\/[^>]*>/gm
    };
  },
  mounted() {
    this.getnewsdata();
  },
  methods: {
    getnewsdata() {
      let url = `http://10.2.115.43:8001/app/isweb/infoservice/getInfoserviceList?con_type_id=0103&innerMS`;
      Axios.get(url).then(res => {
        if (res.data.isSuccess) {
          this.newsContentData = res.data.data.infoserviceDto;
        }
        console.log(res.data.data.infoserviceDto);
        debugger;
      });
    },
    intoNextPage(html){
        this.state1 = false;
        this.state2 = true;
        this.html = html;
    }
  },
  filters: {
    getTimeData(nS) {
      let date = new Date(nS);
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      let hour = date.getHours();
      let min = date.getMinutes();
      let second = date.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
      );
    }
  }
};
</script>
<style scoped>
.newsContent {
  /* border: 1px solid red; */
  /* height: 700px; */
  overflow: auto;
  height: 94%;
}
.newsInfoTitleList {
  /* border: 1px solid red; */
  /* height: 100%; */
  margin-top: 5px;
  display: flex;
  border-bottom: 1px dashed #ccc;
}
.newsInfoTitleList:hover {
  cursor: pointer;
}
.newsInfoTitleList:hover p:nth-child(1) {
  color: #ed4916;
}
.newsInfoTitleListPic {
  width: 50px;
  height: 50px;
  /* border: 1px solid red; */
  margin-right: 5px;
}
.newsInfoTitleListPic img {
  width: 100%;
  height: 100%;
}
.newsInfoTitleListText {
  height: 50px;
  flex: 1;
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
}
.newsInfoTitleListText p:nth-child(1) {
  /* border: 1px solid red; */
  /* height: 50%; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap !important;
  outline: 0 !important;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex: 1;
  align-items: center;
}
.newsInfoTitleListText p:nth-child(2) {
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-left: 5px;
  color: #333;
  /* border: 1px solid red; */
  height: 40%;
}
</style>


// WEBPACK FOOTER //
// src/pages/transNews/xwdt.vue